import { MoreHorizontal, Pencil, KeyRound, Archive, RotateCcw } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { dateShort } from "@/lib/format";

export const DriverRow = ({ driver, onEdit, onReset, onArchive, onRestore }) => {
  const archived = driver.status === "archived";
  return (
    <tr className={`border-t border-slate-100 ${archived ? "bg-slate-50/60 text-slate-500" : "hover:bg-slate-50"}`} data-testid={`driver-row-${driver.user_id}`}>
      <td className="px-4 py-3 max-w-[180px] md:max-w-none">
        <div className="font-semibold truncate">{driver.name || "—"}</div>
        <div className="md:hidden text-xs text-slate-500 truncate">{driver.email}</div>
      </td>
      <td className="hidden md:table-cell px-4 py-3 text-slate-600">{driver.email}</td>
      <td className="hidden sm:table-cell px-4 py-3" data-testid={`driver-active-loads-${driver.user_id}`}>{driver.active_loads}</td>
      <td className="hidden lg:table-cell px-4 py-3 text-slate-500">{dateShort(driver.created_at)}</td>
      <td className="px-4 py-3">
        <span className={`pill ${archived ? "bg-slate-100 text-slate-600 border border-slate-200" : "bg-emerald-50 text-emerald-700 border border-emerald-200"}`} data-testid={`driver-status-${driver.user_id}`}>
          {archived ? "Archived" : "Active"}
        </span>
      </td>
      <td className="px-2 md:px-4 py-3 text-right">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" data-testid={`driver-actions-${driver.user_id}`}><MoreHorizontal className="w-4 h-4" /></Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => onEdit(driver)} data-testid="driver-action-edit"><Pencil className="w-4 h-4 mr-2" /> Edit name</DropdownMenuItem>
            <DropdownMenuItem onClick={() => onReset(driver)} data-testid="driver-action-reset"><KeyRound className="w-4 h-4 mr-2" /> Reset password</DropdownMenuItem>
            {archived ? (
              <DropdownMenuItem onClick={() => onRestore(driver)} data-testid="driver-action-restore"><RotateCcw className="w-4 h-4 mr-2" /> Restore</DropdownMenuItem>
            ) : (
              <DropdownMenuItem onClick={() => onArchive(driver)} className="text-rose-600" data-testid="driver-action-archive"><Archive className="w-4 h-4 mr-2" /> Archive</DropdownMenuItem>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      </td>
    </tr>
  );
};
